const PRINT_BODY_CLASS = "eoy-print-single-report";
const PRINT_ROOT_CLASS = "eoy-print-root";
const PRINTING_CLASS = "eoy-report-printing";
const PRINT_PAGE_CLASS = "eoy-print-page";
const PTM_PRINT_ROOT_CLASS = "eoy-print-root-parent-handout";

function isParentHandout(reportNode) {
  return reportNode.classList?.contains(
    "eoy-report-print-shell-parent-handout",
  );
}

function clearPrintTarget(target) {
  document.body.classList.remove(PRINT_BODY_CLASS);
  target?.sourceNodes?.forEach((node) => node.classList.remove(PRINTING_CLASS));
  target?.root?.remove();
  target?.style?.remove();
  if (target?.cleanupTimer) {
    window.clearTimeout(target.cleanupTimer);
  }
  if (target?.handleAfterPrint) {
    window.removeEventListener("afterprint", target.handleAfterPrint);
  }
}

function buildPrintRoot(reportNodes) {
  const printRoot = document.createElement("div");
  printRoot.className = PRINT_ROOT_CLASS;
  if (reportNodes.every(isParentHandout)) {
    printRoot.classList.add(PTM_PRINT_ROOT_CLASS);
  }

  reportNodes.forEach((reportNode) => {
    const printPage = document.createElement("div");
    printPage.className = PRINT_PAGE_CLASS;

    const printableReport = reportNode.cloneNode(true);
    printableReport.classList.add(PRINTING_CLASS);

    printPage.appendChild(printableReport);
    printRoot.appendChild(printPage);
  });

  return printRoot;
}

function buildPrintStyle(isParentHandoutPrint) {
  const printStyle = document.createElement("style");
  printStyle.textContent = `
    @page {
      size: A4 portrait;
      ${isParentHandoutPrint ? "margin: 14mm;" : ""}
    }
    @media print {
      .${PRINT_PAGE_CLASS}:not(:last-child) {
        break-after: page;
        page-break-after: always;
      }
    }
  `;
  return printStyle;
}

export function printReportNodes(reportNodes) {
  const printableNodes = reportNodes.filter(Boolean);
  if (printableNodes.length === 0) return null;

  const printRoot = buildPrintRoot(printableNodes);
  const printStyle = buildPrintStyle(
    printRoot.classList.contains(PTM_PRINT_ROOT_CLASS),
  );
  const target = {
    cleanupTimer: null,
    root: printRoot,
    sourceNodes: printableNodes,
    style: printStyle,
    handleAfterPrint: null,
  };

  target.handleAfterPrint = () => clearPrintTarget(target);

  document.body.appendChild(printRoot);
  document.head.appendChild(printStyle);
  document.body.classList.add(PRINT_BODY_CLASS);
  printableNodes.forEach((node) => node.classList.add(PRINTING_CLASS));
  window.addEventListener("afterprint", target.handleAfterPrint);

  // Keep print() in the original click activation. Some browsers and embedded
  // browser surfaces suppress a print request deferred through setTimeout.
  target.cleanupTimer = window.setTimeout(() => {
    clearPrintTarget(target);
  }, 120000);

  try {
    window.print();
  } catch (error) {
    clearPrintTarget(target);
    console.warn("Could not open the print dialog:", error);
    return null;
  }

  return () => clearPrintTarget(target);
}
